const getArticleString = function(articleType, key) {
  if (articleType.length === 0) {
    articleType = 'artwork';
  }
  if (key.length === 0) {
    key = 'name';
  }
  const articleConfig = {
    artwork: {
      name: '藝品',
      titleLabel: '藝品導覽',
      headline: '藝品文章列表',
      link: 'artworks',
      captital: 'Artwork',
    },
    temple: {
      name: '廟宇',
      titleLabel: '廟宇導覽',
      headline: '廟宇文章列表',
      link: 'temples',
      captital: 'Temple',
    },
    theme: {
      name: '旅遊',
      titleLabel: '旅遊導覽',
      headline: '旅遊文章列表',
      link: 'themes',
      captital: 'Theme',
    },
    album: {
      name: '圖鑑集',
      headline: '圖鑑集列表',
      titleLabel: '圖鑑集',
      link: 'albums',
      captital: 'Album',
    },
    tag: {
      name: '標籤',
      headline: '標籤列表',
      titleLabel: '標籤列表',
      link: 'tags',
      captital: 'Tag',
    },
    feature: {
      name: '分類',
      headline: '分類列表',
      titleLabel: '分類列表',
      link: 'features',
      captital: 'Feature',
    },
    friend: {
      name: '友善連結',
      headline: '友善連結',
      titleLabel: '友善連結',
      captital: 'Friend',
    },
    sitemap: {
      name: '網站導覽',
      headline: '網站導覽',
      titleLabel: '網站導覽',
      captital: 'Sitemap',
    },
    festival: {
      name: '香科年介紹',
      titleLabel: '香科年介紹',
      headline: '香科年介紹',
      link: 'festivals',
      captital: 'Festival',
    },
    skill: {
      name: '相關課程',
      titleLabel: '相關課程',
      headline: '相關課程',
      link: 'skills',
      captital: 'Skill',
    },
    activityInfo: {
      name: '活動資訊',
      titleLabel: '活動資訊',
      headline: '活動資訊',
      link: 'activityInfos',
      captital: 'Information',
    },
    newInfo: {
      name: '最新消息',
      titleLabel: '最新消息',
      headline: '最新消息',
      link: 'newInfos',
      captital: 'News',
    },
    history: {
      name: '歷史回顧',
      titleLabel: '歷史回顧',
      headline: '歷史回顧',
      link: 'history',
      captital: 'History',
    },
    english: {
      name: 'English',
      titleLabel: 'English',
      headline: 'Tainan Temple Festivals Year',
      link: 'englishes',
      captital: 'English',
    },
    search: {
      name: '搜尋',
      headline: '搜尋',
      titleLabel: '搜尋',
      link: '',
      captital: 'Search',
    },
  };
  return articleConfig[articleType][key];
};

export { getArticleString };
